export default __webpack_public_path__ + "static/media/facebook-dark.c94677f8.svg";